var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6613 8.33055C16.6613 12.4901 12.047 16.822 10.4975 18.1599C10.3531 18.2684 10.1774 18.3271 9.99681 18.3271C9.8162 18.3271 9.64049 18.2684 9.49614 18.1599C7.94663 16.822 3.33228 12.4901 3.33228 8.33055C3.33228 6.563 4.03443 4.86785 5.28427 3.61801C6.53411 2.36817 8.22926 1.66602 9.99681 1.66602C11.7644 1.66602 13.4595 2.36817 14.7093 3.61801C15.9592 4.86785 16.6613 6.563 16.6613 8.33055Z",
    stroke: "#F0E1CE",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99676 10.8299C11.377 10.8299 12.496 9.71101 12.496 8.33074C12.496 6.95047 11.377 5.83154 9.99676 5.83154C8.61649 5.83154 7.49756 6.95047 7.49756 8.33074C7.49756 9.71101 8.61649 10.8299 9.99676 10.8299Z",
    stroke: "#F0E1CE",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon02);
export default __webpack_public_path__ + "static/media/icon02.7b40f974aa91ec1e1072e3be7587e2db.svg";
export { ForwardRef as ReactComponent };